import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './ErrorBoundary.css'

class ErrorBoundary extends Component {
  state = {
    hasError: false,
    errorDetails: null,
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorDetails: error.message,
    }
  }

  componentDidCatch(error, errorInfo) {
    // Enhanced error logging
    console.error('ErrorBoundary caught:', {
      error: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
    })

    // Optional: Send error to an error tracking service
    // this.logErrorToService?.(error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, errorDetails: null })
    window.location.reload()
  }

  handleTryAgain = () => {
    this.setState({ hasError: false, errorDetails: null })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <div className="error-content">
            <div className="error-icon">⚠️</div>
            <h2 className="error-heading">Something Broke!</h2>
            <p className="error-text">
              {this.state.errorDetails || 'An unexpected error occurred.'}
            </p>
            <div className="error-actions">
              <button
                className="error-btn error-btn-primary"
                onClick={this.handleTryAgain}
              >
                Try Again
              </button>
              <button
                className="error-btn error-btn-secondary"
                onClick={this.handleReload}
              >
                Refresh Page
              </button>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ErrorBoundary
